module.exports = __webpack_public_path__ + "img/pwa-ico-192.ad2c76bb.png";